
import './UploadAvatar.css'; // Your custom styles
import { Helmet } from 'react-helmet';
import NRDRUHSHeader from './NRDRUHSHeader'
import NRDRUHSFooter from './NRDRUHSFooter';

function ISSNPage() {
   

    return (
        <div>
           
            <NRDRUHSHeader />

            <Helmet>
                <link rel="canonical" href="https://nrdruh.in/issnpage" />
                <meta name="robots" content="noindex, follow" />
            </Helmet>

            {/* ISSN Content */}
            <div className="container" style={{ paddingTop: 90 }}>
                <h2 className="text-center mb-4" style={{ fontWeight: 'bold' }}>NRD RUHS - ISSN</h2>
            </div>

            <div className="container">
                <div className="row" style={{ marginBottom: 120 }}>
                    <div className="col-md-2" style={{ padding: 30 }}></div>

                    <div className="col-md-8" style={{ padding: 15, textAlign: 'center' }}>
                        <p style={{ textAlign: 'center', lineHeight: 2.1 }}>
                            <b >National Research Denticon – ISSN Print 2395-6844</b><br /><br />
                           
                            <br /><br /><br /><br />
                        </p>
                    </div>

                    <div className="col-md-2" style={{ padding: 15 }}></div>
                </div>
            </div>

            <NRDRUHSFooter />
        </div>
    );
}

export default ISSNPage;
